import { Pipe, PipeTransform } from '@angular/core';
import moment, { Moment } from 'moment';

export const norwegianDateFormats = ['DD.MM.YYYY', 'DD.MM.YY', 'DD-MM-YYYY', 'DD-MM-YY'];

export const parseDateByNorwegianFormats = (date: Date | Moment | string): Moment => {
  let dateMoment: Moment = moment(null);

  for (let i = 0, j = norwegianDateFormats.length; i < j; i = i + 1) {
    dateMoment = moment(date, norwegianDateFormats[i]);

    if (dateMoment.isValid()) {
      return dateMoment;
    }
  }

  return dateMoment;
};

/**
 * Tries to parse strings into a moment date, based on "normal" values we have.
 *
 * @description
 * @param {*} d
 * @returns
 */
export const checkForDate = (d?: Date | Moment | string): Moment | null => {
  let m: Moment;

  if (d instanceof Date) {
    m = moment(d);

    if (m.isValid()) {
      return m;
    }
  }

  if (typeof d === 'string') {
    if (d.length > 10) {
      // probably a decent date string
      m = moment(d);

      if (m.isValid()) {
        return m;
      }
    }
  }

  // Try to parse "norwegian" types.
  if (d) {
    m = parseDateByNorwegianFormats(d);

    if (m.isValid()) {
      return m;
    }
  }

  m = moment(d);

  if (m.isValid()) {
    return m;
  }

  return null;
};

@Pipe({
  name: 'dater',
})
export class DaterPipe implements PipeTransform {
  transform(value: null | Date | moment.Moment | string): Date {
    if (!value) {
      return null;
    }

    const m = checkForDate(value);

    if (!m.isValid()) {
      return null;
    }

    return m.toDate();
  }
}
